module.exports = __webpack_public_path__ + "img/xh-pic2.cbd7521e.png";